// extracted by mini-css-extract-plugin
export default {"paper":"StripeDialog_paper__Kta++","modal":"StripeDialog_modal__xFbRm"};